import React, { useEffect, useState } from "react";
import { DashboardModule } from "@app/dashboard/controls/DashboardModule";
import { useAlerts } from "@app/contexts/useAlerts";
import { DashboardMetricsContainer } from "./DashboardMetrics/dashboardMetricsContainer";

export const DashboardModuleMetrics = () => {
    const { metricsAlerts } = useAlerts();

    return (
        <DashboardModule className="col-span-3 col-start-5 col-end-9 row-span-6">
            <DashboardModule.Header>
                <DashboardModule.Title>Performance Metrics</DashboardModule.Title>
            </DashboardModule.Header>
            <DashboardModule.Body>
                <DashboardMetricsContainer metricsAlerts={metricsAlerts ?? []} />
            </DashboardModule.Body>
        </DashboardModule>
    );
};
